import { SystemIcon } from '@storeblocks/icon';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import styled from 'styled-components';

import { InternalLink } from '@/components/InternalLink';
import { TrackingElement } from '@/tracking';

import { menuItemStyle } from '../styles/menuItemStyle';

interface Props extends ComponentPropsWithoutRef<typeof InternalLink> {
  routeId: string;
  text: string;
}

export const MenuItemLink = forwardRef<HTMLAnchorElement, Props>(
  ({ routeId, text, to, onClick, ...rest }, ref) => {
    return (
      <li>
        <StyledLink
          to={to}
          onClick={onClick}
          data-test={`menu-item-${routeId}`}
          // We can't use `getTrackId` here because it adds the page name to the
          // track-id. We don't want the track-ids in the menu to change for
          // every page change, therefor we're using `menu` to describe placement.
          data-trackid={`${TrackingElement.Link}_go-to-${routeId}_menu`}
          ref={ref}
          {...rest}
        >
          <span className="font-body">{text}</span>
          <StyledSystemIcon name="arrow_right" aria-hidden="true" isPhosphor />
        </StyledLink>
      </li>
    );
  },
);

const StyledSystemIcon = styled(SystemIcon)`
  font-size: 18px;
  color: var(--p-color-text-primary);
`;

const StyledLink = styled(InternalLink)`
  ${menuItemStyle}
`;

MenuItemLink.displayName = MenuItemLink.name;
